export const EMAIL_API_PATH =
  (typeof window !== 'undefined' && window.SITE_MAKER_API_PATH) || '/api/v1'

export const EVENT_API_PATH =
  (typeof window !== 'undefined' && window.SITE_MAKER_API_PATH) || '/api/v1'
